import { render, staticRenderFns } from "./EditProtocol.vue?vue&type=template&id=0f200923&scoped=true"
import script from "./EditProtocol.vue?vue&type=script&lang=js"
export * from "./EditProtocol.vue?vue&type=script&lang=js"
import style0 from "./EditProtocol.vue?vue&type=style&index=0&id=0f200923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f200923",
  null
  
)

export default component.exports